import React, { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { wpService } from '../../services/wpService';
import { LanguageContext } from '../../context/LanguageContext';
import './BlogDetailPage.css';

const BlogDetailPage = () => {
    const { slug, lang } = useParams();
    const navigate = useNavigate();
    const { t } = useContext(LanguageContext);
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPost = async () => {
            setLoading(true);
            const data = await wpService.getPostBySlug(slug);
            if (!data) {
                // Post not found, could redirect to 404
                setLoading(false);
                return;
            }
            setPost(data);
            setLoading(false);
        };
        fetchPost();
    }, [slug]);

    if (loading) {
        return (
            <div className="blog-detail-loading">
                <div className="blog-detail-spinner"></div>
            </div>
        );
    }

    if (!post) {
        return (
            <div className="blog-detail-not-found">
                <h2 className="blog-detail-not-found-title">{t('post_not_found') || 'Post not found'}</h2>
                <button
                    onClick={() => navigate(`/${lang}/blog`)}
                    className="blog-detail-back-button"
                >
                    {t('back_to_blog') || 'Back to Blog'}
                </button>
            </div>
        );
    }

    return (
        <div className="blog-detail-page">
            <a
                onClick={(e) => {
                    e.preventDefault();
                    navigate(`/${lang}/blog`);
                }}
                href={`/${lang}/blog`}
                className="blog-detail-back-link"
            >
                ← {t('back_to_blog') || 'Back to Blog'}
            </a>

            {post.featuredImage && (
                <img
                    src={post.featuredImage}
                    alt={post.title}
                    className="blog-detail-featured-image"
                />
            )}

            <div className="blog-detail-header">
                <p className="blog-detail-meta">
                    {new Date(post.date).toLocaleDateString()} • {post.author}
                </p>
                <h1 className="blog-detail-title">
                    {post.title}
                </h1>
            </div>

            <div
                className="blog-content"
                dangerouslySetInnerHTML={{ __html: post.content }}
            />
        </div>
    );
};

export default BlogDetailPage;
